module.exports = __webpack_public_path__ + "static/media/MatchEat.a80455f7.jpg";